import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import * as cartSlice from "../../store/cart"
import * as productApis from "../../utilities/apis/product"
import * as dealApis from "../../utilities/apis/deal"

import Layout from "../../components/Layout"
import Collapse from "../../components/cart/Collapse"
import CartDealCard from "../../components/cart/CartDealCard"
import CartProductCard from "../../components/cart/CartProductCard"
import CustomerPreferences from "../../components/dashboard/CustomerPreferences"

const Cart = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const cartState = useSelector(state => state.cart)
  const { token, permissions } = useSelector(state => state.user)

  const [deals, setDeals] = useState([])
  const [products, setProducts] = useState([])
  const [customer] = useState(() => JSON.parse(sessionStorage.getItem("customer")))

  const handleEmptyCart = () => {
    dispatch(cartSlice.emptyPos())
  }

  const handleCheckout = () => {
    navigate("/dashboard/checkout")
  }

  const getDeals = async () => {
    try {
      const query = new URLSearchParams()
      const response = await dealApis.getDeals(token, query.toString())
      if (!response.status) throw new Error(response.message)

      setDeals(response.deals)
    } catch (error) {
      alert(error.message)
    }
  }

  const getProducts = async () => {
    try {
      const query = new URLSearchParams()
      const response = await productApis.getProducts(token, query.toString())
      if (!response.status) throw new Error(response.message)

      setProducts(response.products)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    getDeals()
    getProducts()
  }, [])

  const subTotal = cartState.pos.reduce((p, c) => p += cartState.posById[c.slug] * c.price, 0)
  const discount = cartState.pos.reduce((p, c) => p += cartState.posById[c.slug] * c.discount || 0, 0)
  const swap = cartState.pos.reduce((p, c) => {
    if (c.type === "deal")
      p += cartState.posById[c.slug] * c.deal_products.reduce((dp, dc) => dp += dc.swap || 0, 0)
    return p
  }, 0)

  return (
    <Layout
      header={true}
      footer={true}
    >
      <div className="container-fluid">
        <main id="order">
          <section className="d-flex flex-column gap-3 p-3">
            <CustomerPreferences mobile={customer?.mobile} className="card rounded-4 shadow-none p-3" />
            <Collapse type="deal" title="Deals" items={deals} />
            <Collapse type="product" title="Products" items={products} />
          </section>

          <aside className="d-flex flex-column">
            <div className="border border-bottom-0 rounded-top-4 shadow-none">
              <div className="d-flex justify-content-between align-items-center border-bottom p-2">
                <p className="text-body-emphasis fw-bold m-0">Cart ({cartState.pos.length})</p>
                <button className="btn btn-sm btn-light-danger rounded-3" onClick={handleEmptyCart}>Empty</button>
              </div>
              {!!cartState.pos.length && <ul className="list-group list-group-flush shadow-none">
                {cartState.pos.map((item, index) => {
                  return (
                    item.type === "deal"
                      ? <CartDealCard key={`cart-item-${index}`} item={item} index={index} products={products} />
                      : <CartProductCard key={`cart-item-${index}`} item={item} />
                  )
                })}
              </ul>}
              {!cartState.pos.length && <div className="text-center py-5">
                <p className="display-1 text-body-tertiary m-0"><i className="bi bi-bag-x"></i></p>
                <p className="text-body-tertiary fw-bold m-0">No deals or products selected</p>
              </div>}
            </div>
            <div className="cart-footer bg-light mb-3 border rounded-bottom-4 p-2">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p className="text-body-tertiary fw-bold m-0">Sub Total</p>
                <p className="text-body-tertiary fw-bold m-0">Rs. {subTotal.toFixed(2)}</p>
              </div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p className="text-danger fw-bold m-0">Discount</p>
                <p className="text-danger fw-bold m-0">Rs. {discount.toFixed(2)}</p>
              </div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p className="text-success fw-bold m-0">Swap</p>
                <p className="text-success fw-bold m-0">Rs. {swap.toFixed(2)}</p>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <p className="text-body-secondary fw-bold m-0">Total</p>
                <p className="text-body-secondary fw-bold m-0">Rs. {(subTotal - discount + swap).toFixed(2)}</p>
              </div>
            </div>
            {permissions["CREATE_ORDER"] && <button type="submit" className="btn btn-theme rounded-4 w-100" onClick={handleCheckout}>Checkout</button>}
          </aside>
        </main>
      </div>
    </Layout>
  )
}

export default Cart